import React from 'react';
import PropTypes from 'prop-types';
import ReactPlayer from 'react-player'
import Modal from '../Modal';

// import './videoPlayer.scss';

class VideoPlayer extends React.Component {
  constructor(props) {
    super(props);
    this.isTimeout = null;
  }

  static propTypes = {
    isOpen: PropTypes.bool,
    close: PropTypes.func,
    video: PropTypes.object,
  };

  render() {
    const playing = true;
    const controls = true;
    const {
      isOpen,
      close,
      video
    } = this.props;
    return (
      <div className="test">
        <Modal
          isOpen={isOpen}
          onRequestClose={close}
          portalClassName="ReactModalPortal video-player__wrap"
          showCloseIcon
        >
          <div className="video-player">
            <ReactPlayer
              playing={playing}
              controls={controls}
              url={video.videoUrl}
            />
          </div>
        </Modal>
      </div>
    )
  }
}


export default VideoPlayer



// WEBPACK FOOTER //
// ./src/app/components/VideoPlayer/Component.js